function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#FFA14A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M33 177L33 123H43.4161L66.163 157.02V123L77.4981 123L77.4981 177H67.0055L44.2586 142.98L44.2586 177H33Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6272 123H98.1155L98.1155 177H86.6272L86.6272 123Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M107.195 123.077H118.684V147.3L140.129 123.077H154.068L134.385 145.294L155.37 177H141.584L126.266 154.243L118.684 162.806V177H107.195L107.195 123.077Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M159.476 123.077H170.965V147.3L192.41 123.077H206.349L186.665 145.294L207.651 177H193.865L178.547 154.243L170.965 162.806V177H159.476V123.077Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M211.757 123H247.754V132.951L223.246 132.951V145.063L243.159 145.063V154.551L223.246 154.551V167.049L248.597 167.049V177L211.757 177V123Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M255.512 123H267V177H255.512V123Z",
  fill: "white"
});

var SvgNikkei = function SvgNikkei(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNikkei, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NIKKEI.431badbe.svg";
export { ForwardRef as ReactComponent };